// @flow
import {useEffect} from "react";
import {applyRoutePolicy, resetRouteMeta, setForceNoindex} from "../../helper/pageMeta";
import {isHostedVariant, warnOnRoutingMismatch} from "../../helper/routerMode";

type RouteMetaProps = {
    history: any,
    shopRouting?: ?string,
};

// a dealer whose own site addresses products indexably owns the canonical URLs; the hosted
// variant then stays out of the index for that dealer
const OWN_SITE_INDEXABLE = ["QUERY", "PATH"];

/**
 * Route-derived head signals (canonical, robots). Content-derived signals
 * (title, description, JSON-LD) stay with the page components.
 */
const RouteMeta = ({history, shopRouting}: RouteMetaProps) => {
    useEffect(() => {
        applyRoutePolicy(history.location.pathname);
        const unlisten = history.listen(location => applyRoutePolicy(location.pathname));
        return () => {
            unlisten();
            resetRouteMeta();
        };
    }, [history]);

    useEffect(() => {
        if (isHostedVariant()) {
            setForceNoindex(OWN_SITE_INDEXABLE.includes(String(shopRouting || "").toUpperCase()));
            applyRoutePolicy(history.location.pathname);
        } else {
            warnOnRoutingMismatch(shopRouting);
        }
    }, [history, shopRouting]);

    return null;
};

export default RouteMeta;
